import changeHTML from './change-html';
import connectMappedHTML from './connect-mapped-html';
import copyElement from './copy-element';
import cutElement from './cut-element';
import deleteElement from './delete-element';
import duplicateElement from './duplicate-element';
import insertBlock from './insert-block';
import insertElement from './insert-element';
import pasteElement from './paste-element';
import replaceElement from './replace-element';
import setScrollPosition from './set-scroll-position';
import setScrollStatus from './set-scroll-status';
import setSelectedElement from './set-selected-element';
import setSelection from './set-selection';
import shiftElement from './shift-element';
import removeElementAttribute from './remove-element-attribute';
import setElementAttribute from './set-element-attribute';
import setInlineElementStyle from './set-inline-element-style';
import setFocusedElement from './set-focused-element';
import setHoveredElement from './set-hovered-element';
import setLoadedStatus from './set-loaded-status';
import setDisabledStatus from './set-disabled-status';
import blurFocusedElement from './blur-focused-element';
import synchronizeElement from './synchronize-element';
import setChildrenPresence from './set-children-presence';
import bulkSetChildrenPresence from './bulk-set-children-presence';
import bulkViewActions from './bulk-view-actions';
import forceReloadView from './force-reload-view';
import setResponsiveAttribute from './set-responsive-attribute';
import updateAtomicCSS from './update-atomic-css';

export default {
  changeHTML,
  connectMappedHTML,
  copyElement,
  cutElement,
  deleteElement,
  duplicateElement,
  insertBlock,
  insertElement,
  pasteElement,
  replaceElement,
  setSelectedElement,
  setSelection,
  setFocusedElement,
  setHoveredElement,
  setScrollPosition,
  setScrollStatus,
  setLoadedStatus,
  setDisabledStatus,
  shiftElement,
  removeElementAttribute,
  setElementAttribute,
  setInlineElementStyle,
  blurFocusedElement,
  synchronizeElement,
  setChildrenPresence,
  bulkSetChildrenPresence,
  bulkViewActions,
  forceReloadView,
  setResponsiveAttribute,
  updateAtomicCSS,
};
